import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.herosofthegrid.simwebtech.com';

interface ForgotPasswordFormProps {
  onBackToLogin: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [resetLink, setResetLink] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setResetLink('');
    setIsLoading(true);

    try {
      const frontendUrl = window.location.origin;
      const response = await fetch(`${API_URL}/api/PasswordReset/request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          frontendUrl
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);

        // In development, show the reset link
        if (data.resetLink) {
          setResetLink(data.resetLink);
        }

        setEmail('');
      } else {
        setError(data.message || 'An error occurred');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-form">
      <h2>Reset Your Password</h2>
      <p className="reset-instructions">
        Enter your email address and we'll send you a link to reset your password.
      </p>

      {message && (
        <div className="success-message">
          {message}
          {resetLink && (
            <div className="dev-reset-link">
              <p><strong>Development Mode - Reset Link:</strong></p>
              <a href={resetLink} target="_blank" rel="noopener noreferrer">
                Click here to reset your password
              </a>
            </div>
          )}
        </div>
      )}

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
            placeholder="Enter your email"
          />
        </div>

        <button type="submit" disabled={isLoading} className="submit-button">
          {isLoading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>

      <div className="auth-footer">
        <button onClick={onBackToLogin} className="link-button">
          ← Back to Login
        </button>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
